import React from 'react';
import moment from 'moment';
import { ReactComponent as Trash } from '../../../../../common/images/bin.svg';

export default (users, write, searchPropsFactory, handleTableIcon) => [
  {
    dataIndex: 'user_id',
    title: 'Пользователь',
    ...(() => {
      const searchProps = searchPropsFactory('user_id', 'Пользователь');
      return {
        ...searchProps,
        onFilter: (value, record) => {
          const user = users.find((el) => el.id === record.user_id);
          const username = user ? user.username : '';
          return username.toLowerCase().includes(value.toLowerCase());
        },
        render: (cell) => {
          const user = users.find((el) => el.id === cell);
          const username = user ? user.username : '';
          return searchProps.render ? searchProps.render(username) : username;
        },
      };
    })(),
  },
  {
    dataIndex: 'session',
    title: 'Сессия',
    ...searchPropsFactory('session', 'Сессия'),
  },
  {
    dataIndex: 'constant',
    title: 'Тип',
    ...(() => {
      const searchProps = searchPropsFactory('constant', 'Тип');
      return {
        ...searchProps,
        onFilter: (value, record) => {
          const displayText = record.constant ? 'Постоянная' : 'Временная';
          return displayText.toLowerCase().includes(value.toLowerCase());
        },
        render: (cell) => {
          const displayText = cell ? 'Постоянная' : 'Временная';
          return searchProps.render ? searchProps.render(displayText) : displayText;
        },
      };
    })(),
  },
  {
    dataIndex: 'created_on',
    title: 'Дата создания',
    ...(() => {
      const searchProps = searchPropsFactory('created_on', 'Дата создания');
      return {
        ...searchProps,
        onFilter: (value, record) => {
          const formattedDate = moment(record.created_on, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
          return formattedDate.toLowerCase().includes(value.toLowerCase());
        },
        render: (cell) => {
          const formattedDate = moment(cell, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
          return searchProps.render ? searchProps.render(formattedDate) : formattedDate;
        },
      };
    })(),
  },
  {
    dataIndex: 'Settings',
    title: '',
    width: 50,
    render: (_, row) => (
      <span
        className="anticon"
        onClick={(e) => handleTableIcon(e, row)}
        style={{ cursor: 'pointer' }}
      >
        <Trash style={{ width: '20px', height: '20px' }} />
      </span>
    ),
  },
];
